import React, { useEffect, useState } from "react";
import { useReceiptData } from "./handlers/useReceiptData";
import ReceiptHeader from "./ReceiptHeader";
import LeftCard from "./LeftCard";
import RightCard from "./RightCard";
import { Snackbar } from "@mui/material";
import AlertBar from "../common/alert";
import LoadingModal from "./LoadingModal";

const PaymentPage: React.FC = () => {
  const [paymentHandled, setPaymentHandled] = useState(false);
  const [showLoadingModal, setShowLoadingModal] = useState(false);
  const [alert, setAlert] = useState({
    show: false,
    severity: "info",
    title: "",
    message: "",
  });
  const { data } = useReceiptData(setAlert);

  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (paymentHandled) return;
      if (
        event.data &&
        (event.data.type === "PAYMENT_SUCCESS" ||
          event.data.type === "PAYMENT_FAILED") &&
        event.data.status
      ) {
        setAlert({
          show: true,
          severity: event.data.status === "success" ? "success" : "error",
          title: event.data.status === "success" ? "Success" : "Error",
          message:
            event.data.message ||
            (event.data.status === "success"
              ? "Payment succeeded."
              : "Payment failed."),
        });
        setPaymentHandled(true);
      }
    };
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [paymentHandled]);

    useEffect(() => {
    if (!alert.show && alert.severity === "success" && paymentHandled) {
      setShowLoadingModal(true);
    }
  }, [alert.show, alert.severity, paymentHandled]);
  
  return (
    <div className="bg-nobel-50 min-h-screen w-full flex flex-col">
      <div className="shrink-0">
        <ReceiptHeader data={data} />
      </div>
      <div className="flex flex-col md:flex-row md:gap-5 md:px-5 md:mt-5 w-full max-w-7xl mx-auto">
        {/* Left Card: 5/8 on desktop, full on mobile */}
        <div className="w-full md:w-[62%]"> 
          <LeftCard data={data} />
        </div>
        {/* Right Card: 3/8 on desktop, full on mobile */}
        <div className="w-full md:w-[38%] md:flex md:flex-col">
          <RightCard data={data} paymentCompleted={paymentHandled} />
        </div>
      </div>
      <Snackbar
        open={!!alert.show}
        sx={{ width: "95%" }}
        autoHideDuration={60000} // 60s
        onClose={() => setAlert({ ...alert, show: false })}
      >
        <AlertBar
          severity={alert.severity as any}
          show={!!alert.show}
          title={alert.title}
          message={typeof alert.message === "string" ? alert.message : ""}
          onClose={() => setAlert({ ...alert, show: false })}
        />
      </Snackbar>
      <LoadingModal open={showLoadingModal} />
    </div>
  );
};

export default PaymentPage;
